"use client";

import { motion, useReducedMotion, type Variants } from "framer-motion";
import { type ReactNode } from "react";

// Fade + lift children into view the first time they're scrolled to.
const variants: Variants = {
    hidden: { opacity: 0, y: 28 },
    visible: { opacity: 1, y: 0 },
};

type RevealProps = {
    children: ReactNode;
    delay?: number;
    className?: string;
};

export const Reveal = ({ children, delay = 0, className }: RevealProps) => {
    const reduce = useReducedMotion();

    // Honour reduced-motion: render statically with no animation at all.
    if (reduce) return <div className={className}>{children}</div>;

    return (
        <motion.div
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay, ease: [0.21, 0.5, 0.3, 1] }}
            variants={variants}
        >
            {children}
        </motion.div>
    );
};
